import { render, staticRenderFns } from "./AreaPlantadaSojaArgentina20242025.vue?vue&type=template&id=00af7c09&lang=pug"
import script from "./AreaPlantadaSojaArgentina20242025.vue?vue&type=script&lang=js"
export * from "./AreaPlantadaSojaArgentina20242025.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports